















































import { Component, Vue } from 'vue-property-decorator';
import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src
import axios from 'axios';

    Component({
        components: {
            HelloWorld,
        },
    })
        export default Vue.extend({
            data() {
                return {
                    choice: 0,
                    id: '',
                    html:'',
                }
            },
            methods: {
                async updateSubscription() {
           
                },

                 async getData() {
                    await axios.get('/api/PageData/page/'+this.id)
                        .then((resp) => {
                            //alert(JSON.stringify(resp.data));
                            this.html=resp.data;
                        })
                }
            },
            async mounted() {
                if (this.$route.query.id==undefined) {
                    this.$router.push("/");
                }
                this.id = this.$route.query.id as string;
                await this.getData();

            }
        })
